// eslint-disable-next-line import/no-extraneous-dependencies
import { useState, useRef, useEffect } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const useAssetExtractor = (externalProcessor) => {
  const [state, setState] = useState({
    status: 'idle',
    progress: 0,
    message: '',
    error: null,
    createdAssetId: null,
    duration: '0.000',
  });

  const timerRef = useRef(null);
  const startTimeRef = useRef(null);

  // --- LÓGICA DE TIMER ROBUSTA ---
  const startTimer = () => {
    // 1. Limpiar cualquier intervalo previo
    if (timerRef.current) clearInterval(timerRef.current);

    // 2. Marcar tiempo de inicio
    startTimeRef.current = Date.now();

    // 3. Iniciar intervalo
    timerRef.current = setInterval(() => {
      if (!startTimeRef.current) return;
      const now = Date.now();
      const elapsed = (now - startTimeRef.current) / 1000;

      // Actualización funcional para no depender de cierres antiguos
      setState((s) => ({ ...s, duration: elapsed.toFixed(3) }));
    }, 100);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const processFile = (file) => {
    // A. RESETEAR Y ARRANCAR VISUALMENTE YA
    stopTimer();
    setState({
      status: 'negotiating',
      progress: 5,
      message: 'Starting...',
      duration: '0.000',
      error: null,
      createdAssetId: null,
    });

    // Arrancamos el timer explícitamente aquí
    startTimer();

    // B. CALLBACKS
    const uiCallbacks = {
      onStatus: (st, msg) => setState((s) => ({ ...s, status: st, message: msg || s.message })),
      onProgress: (pg) => setState((s) => ({
        ...s,
        progress: pg > s.progress ? pg : s.progress, // Solo sube
      })),
      onMessage: (msg) => setState((s) => ({ ...s, message: msg })),
      onError: (err) => setState((s) => ({ ...s, status: 'error', error: err })),
      onSuccess: (id) => setState((s) => ({
        ...s, status: 'success', createdAssetId: id, progress: 100,
      })),
      stopTimer,
      startTimer,
    };

    // C. EJECUTAR LÓGICA EXTERNA (DESACOPLADA)
    // Usamos setTimeout(..., 10) para que React tenga tiempo de renderizar el
    // estado "Starting..." y arrancar el timer ANTES de que el procesador congele el hilo.
    setTimeout(() => {
      if (externalProcessor && typeof externalProcessor === 'function') {
        externalProcessor(file, uiCallbacks);
      } else {
        stopTimer();
        setState((s) => ({ ...s, status: 'error', error: 'Configuration Error' }));
      }
    }, 10);
  };

  const reset = () => {
    stopTimer();
    setState({
      status: 'idle', progress: 0, message: '', error: null, duration: '0.000', createdAssetId: null,
    });
  };

  return { ...state, processFile, reset };
};
